module.exports = __webpack_public_path__ + "img/Screen3.68952c98.png";